import merge from 'lodash/merge';
//
import { button } from './components/button';
import { textField } from './components/textfield';
import { switches } from './components/switch';
import { list } from './components/list';
import { typography } from './components/typography';
import { dataGrid } from './components/data-grid';
import { chip } from './components/chip';
import { breadcrumbs } from './components/breadcrumbs';
import { select } from './components/select';
import { tabs } from './components/tabs';
import { accordion } from './components/accordion';
import { datePicker } from './components/date-picker';
import { checkbox } from './components/checkbox';
import { autocomplete } from './components/autocomplete';
import { dialog } from './components/dialog';
import IconButton from './components/icon-button';
import { radio } from './components/radio';
import { pagination } from './components/pagination';
// ----------------------------------------------------------------------
export function componentsOverrides(theme) {
    const components = merge(button(theme), textField(theme), switches(theme), list(theme), typography(theme), dataGrid(theme), chip(theme), breadcrumbs(theme), select(theme), tabs(theme), accordion(theme), datePicker(theme), checkbox(theme), autocomplete(theme), dialog(theme), IconButton(theme), radio(theme), pagination(theme));
    return components;
}
